module.exports = __webpack_public_path__ + "img/hruba-stavba.6e14601b.svg";